export default __webpack_public_path__ + "static/media/ic_flag_vietnamese.59bcfd1e.svg";